<div >
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span *ngIf="mensaje"> {{mensaje}}{{dots}}</span>
</div>